<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <v-row
    :class="getClasses"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </v-row>
</template>

<script>
export default {
  name: 'Row',
  computed: {
    getClasses: () => [
      'app-row'
    ].join(' ')
  }
}
</script>
